'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   LinkIcon
// } from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListCompareSelectIcon = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListCompareSelectIcon, _Component);

  //
  function IyvListCompareSelectIcon(props) {
    (0, _classCallCheck3.default)(this, IyvListCompareSelectIcon);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListCompareSelectIcon.__proto__ || (0, _getPrototypeOf2.default)(IyvListCompareSelectIcon)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListCompareSelectIcon, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var compareSelectStyles = this.props.getCompareSelectStyles(this.props.cart, this.props.shareclass.investment_vehicle_id);
      //
      return _react2.default.createElement(
        'span',
        { onClick: function onClick() {
            _this2.props.clickCompareSelect(_this2.props.shareclass);
          } },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('i', {
            className: compareSelectStyles.className,
            styleName: compareSelectStyles.styleName
          })
        ),
        this.props.displayLabel ? _react2.default.createElement(
          'span',
          null,
          'Compare'
        ) : null
      );
    }
  }]);
  return IyvListCompareSelectIcon;
}(_react.Component), _class2.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickCompareSelect: _react.PropTypes.func.isRequired,
  getCompareSelectStyles: _react.PropTypes.func.isRequired,
  cart: _react.PropTypes.object,
  displayLabel: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = IyvListCompareSelectIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListCompareSelectIcon.js
// module id = 1371
// module chunks = 0